module.exports = __webpack_public_path__ + "static/img/2.a55bf5f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/staff/2.jpg
// module id = 195
// module chunks = 1